import { render, staticRenderFns } from "./PrintSIF.vue?vue&type=template&id=9f5a7d46&scoped=true&"
import script from "./PrintSIF.vue?vue&type=script&lang=js&"
export * from "./PrintSIF.vue?vue&type=script&lang=js&"
import style0 from "./PrintSIF.vue?vue&type=style&index=0&id=9f5a7d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5a7d46",
  null
  
)

export default component.exports